import { isMockEnabled } from "@/lib/mock-flags";
import * as real from "./real";
import * as mock from "../mocks/api";

export function getAuthClient() {
  return isMockEnabled("auth") ? mock : real;
}

export type { AuthUser } from "../stores/authStore";
